import React, { createContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { DefaultArrayEmpty, FnAxios, FnDialog, I18n, getMonthDifference } from "utilities/utilities";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import moment from "moment";
import DateRangeProject from "view/FrontEnd/Project/components/DateRange";
import NumberInputCustom from "../../components/NumberInputCustom";

export default function WorkPlanDuration(props) {
    const {
        nYear,
        formDuration,
        onAddDuration,
        onDeleteDuration,
        arrDuration = [],
        dataRowProject,
        isPermission,
        dStart,
        dEnd,
        trigger,
    } = props;

    const DialogFn = FnDialog();
    
    const [nTrigger, setnTrigger] = useState(trigger);

    // const [_dStart, setdStart] = useState(dStart);
    // const [_dEnd, setdEnd] = useState(dEnd);

    const handleChangeWeight = (nID) => {
        //#region แบบทุกกิจกรรม
        // let clone = [...dataRowProject];
        // let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => parseInt(f.nID) === parseInt(nID));
        // let nWeight = lstData.map(m => parseInt(m.nWeight) || 0).reduce((a, b) => a + b, 0);
        // let nSum = nWeight;
        // arrDuration.forEach(f => {
        //     let nDiff = moment(formDuration.getValues(`sEndMonth_${f.nID}`)).diff(moment(formDuration.getValues(`sStartMonth_${f.nID}`)), "month");
        //     let nWeight = 0;
        //     let _nWeight = formDuration.getValues(`nWeight_${f.nID}`);
        //     if (!isNaN(nDiff) && _nWeight) {
        //         nWeight = parseInt(_nWeight) * (nDiff + 1);
        //     }
        //     nSum += nWeight;
        // })
        //#endregion

        //#region เฉพาะกิจกรรม
        let nSum = 0;
        arrDuration.forEach(f => {
            let nDiff = moment(formDuration.getValues(`sEndMonth_${f.nID}`)).diff(moment(formDuration.getValues(`sStartMonth_${f.nID}`)), "month");
            let nWeight = 0;
            let _nWeight = formDuration.getValues(`nWeight_${f.nID}`);
            if (!isNaN(nDiff) && _nWeight) {
                nWeight = parseInt(_nWeight) * (nDiff + 1);
            }
            nSum += nWeight;
        })
        //#endregion

        if (nSum > 100) {
            DialogFn.Warning("จำนวนผลรวมค่าน้ำหนักต่อเดือนเกิน 100.", () => {
                formDuration.setValue(`nWeight_${nID}`, null);
            }, () => {
                formDuration.setValue(`nWeight_${nID}`, null);
            });
        }
    }

    //// const OnCheckDuplicate = (date, clone) => {
    ////     let isDuplicate = false;
    ////     clone.forEach(item => {
    ////         let start = moment(formDuration.getValues("sStartMonth_" + item.nID)).startOf("month").year(nYear);
    ////         let end = moment(formDuration.getValues("sEndMonth_" + item.nID)).endOf("month").year(nYear);
    ////         if (start.isValid && end.isValid) {
    ////             let isBetween = date.isBetween(start, end, "month", "[]");
    ////             if (isBetween) {
    ////                 isDuplicate = true;
    ////                 return true;
    ////             }
    ////         }
    ////     });
    ////     return isDuplicate;
    //// }

    const OnCheckDuplicate = (date, clone, nID) => {
        let isDuplicate = false;
        clone.forEach(item => {
            let start = moment(formDuration.getValues("sStartMonth_" + item.nID)).startOf("month").year(nYear);
            let end = moment(formDuration.getValues("sEndMonth_" + item.nID)).endOf("month").year(nYear);
            if (start.isValid() && end.isValid()) 
            {
                // เริ่มต้น - สิ้นสุดของช่วงใหม่
                let newStart = moment(formDuration.getValues("sStartMonth_" + nID)).startOf("month").year(nYear);
                let newEnd = moment(formDuration.getValues("sEndMonth_" + nID)).endOf("month").year(nYear);
                // เงื่อนไขการทับซ้อนช่วง: ช่วงใหม่เริ่มก่อน end เดิม และสิ้นสุดหลัง start เดิม
                const isOverlap = newStart.isSameOrBefore(end) && newEnd.isSameOrAfter(start);
                if (isOverlap) {
                    isDuplicate = true;
                    return true;
                }
            }
        });
        return isDuplicate;
    };

    const handleOnChange = (e, nID, type) => {
        let isDuplicate = false;
        let clone = [...arrDuration].filter(f => f.nID !== nID);
        if (e) {
            let date = type === "start" ? moment(e).startOf("month").year(nYear) : moment(e).endOf("month").year(nYear);
            isDuplicate = OnCheckDuplicate(date, clone, nID);
            handleChangeWeight(nID);
            if (isDuplicate) {
                DialogFn.Warning("ช่วงเวลาซ้ำ");
                if (type === "start") {
                    formDuration.setValue("sStartMonth_" + nID, null);
                } else {
                    formDuration.setValue("sEndMonth_" + nID, null);
                }
                //// setnTrigger(nTrigger + 1);
                setnTrigger(v=> v + 1);
            }
        }
    }

    return (
        <Grid item xs={12} md={12} container spacing={2}>
            <FormProvider {...formDuration}>
                {(arrDuration ||[]).map((m, i) => {
                    return (
                        <Grid item container spacing={2} key={"key_duration_" + m.nID}>
                            <Grid item xs={12} md={7}>
                                <DateRangeProject
                                    NameStart={`sStartMonth_${m.nID}`}
                                    NameEnd={`sEndMonth_${m.nID}`}
                                    LabelStart={'เริ่มต้น'}
                                    LabelEnd={'สิ้นสุด'}
                                    IsMonthPicker={true}
                                    nID={m.nID}
                                    required={true}
                                    isDisableYear={true}
                                    nYearMapper={nYear}
                                    onChange={handleOnChange}
                                    minDate={dStart}
                                    maxDate={dEnd}
                                    nTrigger={nTrigger}
                                    disabled={!isPermission}
                                    formatDefault={"MMMM"}    
                                    form={formDuration}                        
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <InputNumberItem
                                    id={`nWeight_${m.nID}`}
                                    name={`nWeight_${m.nID}`}
                                    label={"ค่าน้ำหนักต่อเดือน"}
                                    IsComma={true}
                                    IsAllowScientific={false}
                                    type={"Number"}
                                    ShowDigits={0}
                                    maxDigits={0}
                                    max={100}
                                    min={0}
                                    maxInteger={3}
                                    endAdornment={"ร้อยละ"}
                                    required={true}
                                    disabled={!isPermission}
                                    onChange={() => { handleChangeWeight(m.nID) }}
                                />
                                {/* <NumberInputCustom
                                    id={`nWeight_${m.nID}`}
                                    name={`nWeight_${m.nID}`}
                                    label={"ค่าน้ำหนักต่อเดือน"}
                                    required={true}
                                    IsAllowScientific={false}
                                    maxDigits={0}
                                    ShowDigits={0}
                                    maxInteger={3}
                                    IsCanMinus={false}
                                    IsComma={false}
                                    min={0}
                                    endAdornment={"ร้อยละ"}
                                    disabled={!isPermission}
                                    onChange={() => { handleChangeWeight(m.nID) }}
                                /> */}
                            </Grid>
                            {isPermission &&
                                <Grid item xs={6} md={2}>
                                    <Grid container spacing={2}>
                                        {(arrDuration || []).length === i + 1 &&
                                            <Grid item>
                                                <BtnAdd
                                                    sColor="#00B393"
                                                    sColorHover="#009278"
                                                    id="AddDuration"
                                                    txt={'เพิ่มช่วงเวลา'}
                                                    IsCircleWithOutText
                                                    // onClick={formDuration.handleSubmit(onAddDuration(m.nActivityID), (err) => {
                                                    //     document.getElementById(Object.keys(err)[0])?.focus();
                                                    // })}
                                                    onClick={formDuration.handleSubmit((e) => onAddDuration(m.nActivityID),(err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                        console.log("err", err)
                                                    })}
                                                />
                                            </Grid>
                                        }
                                        {(arrDuration || []).length > 1 &&
                                            <Grid item>
                                                <BtnDelete
                                                    sColorHover="#d30d1e"
                                                    id="DeleteDuration"
                                                    IsCircleWithOutText
                                                    onClick={() => onDeleteDuration(m.nID)}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    )
                })}
            </FormProvider>
        </Grid>
    )
}